import { combineReducers } from "redux";
import authReducer from "./authReducer";
import catalogReducer from "./catalogReducer";
import settingReducer from "./settingReducer";
import MenuManage from "./MenuManagementReducer";
import restaurantReducer from "./restaurantReducer";
import subAdminReducer from "./subAdminReducer";
import staffReducer from "./staffReducer";
import requestReducer from "./RequestReducer";
import statsReducer from "./statsReducer";
import checkoutQuestionReducer from "./checkoutQuestionReducer";
import customerReducer from "./customerReducer";
import orderReducer from "./orderReducer";
import faqsReducer from "./faqsReducer";
import tutorialsReducer from "./tutorialsReducer";
import cartReducer from "./cartReducer";
import contactReducer from "./contactReducer";
import driverReducer from "./driverReducer";
import subscriptionReducer from "./subscriptionReducer";
import MenuReducer from "./menuReducer";
import labelsReducer from "./labelsReducer";
import categoriesReducer from "./categoriesReducer";
import itemsReducer from "./itemsReducer";
import offerReducer from "./offersReducer";
import addOnsReducer from "./addOnsReducer";
import tableReducer from "./tableReducer";

const appReducer = combineReducers({
  auth: authReducer,
  catalog: catalogReducer,
  setting: settingReducer,
  offer: offerReducer,
  menu: MenuManage,
  restaurant: restaurantReducer,
  admin: subAdminReducer,
  staff: staffReducer,
  driver: driverReducer,
  requests: requestReducer,
  stats: statsReducer,
  checkoutQuestion: checkoutQuestionReducer,
  customer: customerReducer,
  orders: orderReducer,
  faqs: faqsReducer,
  tutorials: tutorialsReducer,
  cart: cartReducer,
  contacts: contactReducer,
  subscription: subscriptionReducer,
  menus: MenuReducer,
  label: labelsReducer,
  category: categoriesReducer,
  item: itemsReducer,
  addOns: addOnsReducer,
  table: tableReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    state = undefined;
  }

  return appReducer(state, action);
};
export default rootReducer;
